function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { first } from 'lodash';
import { DEBUG } from './constants';

export var Errors = function () {
  function Errors(dispatch) {
    _classCallCheck(this, Errors);

    this.dispatch = dispatch;
  }

  Errors.prototype.async = function async(error, callback) {
    if (!first(error)) {
      DEBUG && console.log(error);
      throw error;
    }

    switch (first(error).status) {
      case 401:
        DEBUG && console.log(error);
        this.dispatch(callback());
        break;

      default:
        DEBUG && console.log(error);
        throw error;
    }
  };

  return Errors;
}();


//////////////////
// WEBPACK FOOTER
// ../ui-utilities/es/errors.js
// module id = 594
// module chunks = 4